import React, { useState } from 'react';
import {
  Paper,
  TextField,
  Button,
  Box,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { LLMRequestDTO } from '../types/api';
import { useAuthToken } from '../hooks/useAuthToken';
import { PLACEHOLDERS } from '../utils/constants';
import { promptInputStyles } from '../styles';

interface PromptInputProps {
  onSubmit: (request: LLMRequestDTO) => void;
  loading?: boolean;
  error?: string;
}

const PromptInput: React.FC<PromptInputProps> = ({ onSubmit, loading = false, error }) => {
  const [requirements, setRequirements] = useState('');
  const { token, updateToken } = useAuthToken();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (requirements.trim() && token.trim()) {
      const request: LLMRequestDTO = {
        requirements: requirements.trim(),
        token: token.trim()
      };
      onSubmit(request);
    }
  };

  const handleClear = () => {
    setRequirements('');
    updateToken('');
  };

  const isFormValid = requirements.trim() && token.trim();

  return (
    <Paper elevation={2} sx={promptInputStyles.paper}>
      <Typography variant="h6" sx={promptInputStyles.title}>
        Генерация фич-листа
      </Typography>
      
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Токен авторизации"
          value={token}
          onChange={(e) => updateToken(e.target.value)}
          placeholder={PLACEHOLDERS.TOKEN}
          disabled={loading}
          sx={promptInputStyles.tokenField}
          required
        />

        <TextField
          fullWidth
          multiline
          rows={4}
          label="Введите требования к проекту"
          value={requirements}
          onChange={(e) => setRequirements(e.target.value)}
          placeholder={PLACEHOLDERS.REQUIREMENTS}
          disabled={loading}
          sx={promptInputStyles.requirementsField}
          required
        />

        {error && (
          <Alert severity="error" sx={promptInputStyles.errorAlert}>
            {error}
          </Alert>
        )}

        <Box sx={promptInputStyles.buttonContainer}>
          <Button
            type="submit"
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
            disabled={loading || !isFormValid}
            sx={promptInputStyles.submitButton}
          >
            {loading ? 'Генерация...' : 'Сгенерировать'}
          </Button>
          
          <Button variant="outlined" onClick={handleClear} disabled={loading}>
            Очистить
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default PromptInput; 